import { emptyObject } from 'ui-components/default-props/empty';
import { baseReducer as BaseReducer } from '../core/base-reducer';

import * as Actions from './create-label-content.actions';

const initialState = {
  configureLabelModel: emptyObject,
};

const actionHandlerMap = {
  [Actions.CREATE_LABEL_CONTENT_SET_FULFILLMENT_PLAN_ID]: (state, { fulfillmentPlanId }) => {
    return {
      ...state,
      fulfillmentPlanId,
    };
  },
  [Actions.CREATE_LABEL_CONTENT_SET_COST_REVIEW_GUID]: (state, { costReviewJobGuid }) => {
    return {
      ...state,
      costReviewJobGuid,
    };
  },
};

export const ConnectedActionHandlerMap = BaseReducer(initialState, actionHandlerMap);

export { namespace } from './create-label-content.reducer.metadata';
